// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container_FDP9U","CommentCard":"CommentCard_uIhMr"};